<div class="container">
  <label
    class="date-picker-input"
    (click)="onInputClick($event)"
    [class.error]="showError"
    [class.disabled]="disabled"
    #dateInput
  >
    <span class="date-text">{{ labelText }}</span>
    <i class="material-icons today">today</i>
  </label>
  <div *ngIf="showCalendar" class="date-picker" #datePickerMenu>
    @if(dateInputLabel == 'crd') {
      <mat-calendar
        [selected]="calendarDate"
        [startAt]="calendarDate"
        (selectedChange)="onDateSelect($event)"
        [dateFilter]="dateHolidayWeekendFilter"
        [minDate]="min"
        [maxDate]="max"
        (yearSelected)="yearSelectedCall($event)"
        #calendar
      >
      </mat-calendar>
    } @else {
      <mat-calendar
        [selected]="calendarDate"
        [startAt]="calendarDate"
        (selectedChange)="onDateSelect($event)"
        [dateFilter]="dateFilter"
        [minDate]="min"
        [maxDate]="max"
        (yearSelected)="yearSelectedCall($event)"
        #calendar
      >
      </mat-calendar>
    }
  </div>
</div>
